import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Skeleton } from "@material-ui/lab";

interface myProps {
  loading: boolean;
  isAllowed?: boolean;
  hideBackgroundColor?: boolean;
}

interface LoadingProps {
  isLoading: boolean;
  children: React.ReactNode;
  isAllowed?: boolean,
  width?: number | string;
  height?: number | string;
  disableParentWidth?: boolean;
  customstyle?: any;
}

const useStyles = makeStyles(() => ({
  root: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
  },
  circularContainer: {
    position: "absolute",
    left: "50%",
    top: "40%",
    transform: "translate(-50%, -50%)",
  },
}));

export default function Loader(props: myProps) {
  const classes = useStyles();
  const { isAllowed = false, hideBackgroundColor } = props
  return props.loading ? (
    <div style={{ display: isAllowed ? "block" : "none", backgroundColor: hideBackgroundColor ? "" : "rgb(0, 0, 0, .4)" }} className={classes.root}>
      <div className={classes.circularContainer}>
        <CircularProgress />
      </div>
    </div>
  ) : (
    <div />
  );
}

export const LoadingComponent = (props: LoadingProps) => {
  const {
    isLoading,
    width = "100%",
    height,
    isAllowed = true,
    children,
    disableParentWidth,
    customstyle,
  } = props;

  if (isLoading) {
    return (
      <Skeleton
        width={width}
        height={height}
        animation='wave'
        variant='rect'
        style={customstyle}
      />
    );
  }

  return <div style={{ display: isAllowed ? "block" : "none", width: disableParentWidth ? "" : "100%" }}>
    {children}
  </div>
}